module.exports = "/_next/static/images/yigit-68fc8b8881b37a38b341d2864d53f4af.png";